import { client } from '@repo/shared-kit/utils';
import { apiBaseURL } from 'receivable-invoices-js/constants/hosts';
import { waitForFetch } from 'receivable-invoices-js/utils/wait-for-fetch';

client.init({
  baseURL: apiBaseURL,
  fetch: (...args) => waitForFetch(fetch(...args)),
});
